import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';


export function formatCartItem(itemRow) {
  let product = itemRow.product;
  let productTitle = product.name;
  let variantTitle = '';

  if (itemRow.optionsSelectionsValues) {
    variantTitle = itemRow.optionsSelectionsValues.map((option) => option.value).join("/") || '';
  }

  let item = {};
  item['id'] = `${itemRow.cartItemId}`;
  item['title'] = variantTitle ? `${productTitle} (${variantTitle})` : productTitle;
  item['quantity'] = itemRow.quantity;
  item['price'] = product.price;
  item['product_id'] = `${product.id}`;
  item['product_title'] = productTitle;
  item['variant_id'] = null; // wix doesn't provide variant ID
  item['variant_title'] = variantTitle;
  item['image_url'] = product.media && product.media.mainMedia && product.media.mainMedia.image && product.media.mainMedia.image.url || '';
  return item;
}

export function formatCartResponse(response) {
  // The Wix cart API returns 404 → an empty {} payload when no cart exists
  // yet. Guard every field so an empty-cart event doesn't crash downstream
  // consumers (AOV cart-update handler, etc.).
  let data = {};
  let safe = response || {};

  let currencyFormat = safe.convertedCurrencyFormat || {};
  let totals = safe.convertedTotals || {};

  data['currency'] = currencyFormat.code || null;
  data['total_price'] = totals.subTotal != null ? totals.subTotal : 0;
  data['total_discount'] = totals.discount != null ? totals.discount : 0;

  let items = [];
  if (Array.isArray(safe.items)) {
    safe.items.forEach((itemRow) => {
      let item = formatCartItem(itemRow);
      items.push(item);
    })
  }

  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'wix_cart', {});

  const existingMapper = {};
  if (existingData.items) {
    existingData.items.forEach((itemRow) => {
      existingMapper[`${itemRow.cartItemId}`] = parseInt(itemRow.quantity);
    })
  }

  const currentMapper = {};
  if (response.items) {
    response.items.forEach((itemRow) => {
      currentMapper[`${itemRow.cartItemId}`] = parseInt(itemRow.quantity);
    })
  }

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  if (response.items) {
    response.items.forEach((itemRow) => {
      let itemId = `${itemRow.cartItemId}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })
  }

  return addedItems;
}

export function handleCartUpdate(response) {
  let noChange = isEqual(window.OnVoardEventsData['wix_cart'], response);
  let isNew = !window.OnVoardEventsData['wix_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['wix_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;

  document.addEventListener('ov_trigger_cart_reload', () => {
    loadCart();
  });
}

export function loadCart() {
  import('common/wix-utils')
  .then((wixUtils) => {
      wixUtils.fetchCartData({callback: handleCartUpdate});
  });
}

export function addToCart(productId, kwargs={}) {
  // Adds a product to the Wix cart via the eCom SDK and, when a coupon code is
  // supplied (free-product rewards), applies it at the cart level so the item
  // is discounted immediately. Free product rewards are single-variant, so the
  // catalog item id (product external id) alone resolves the line item.
  import('common/wix-utils')
  .then((wixUtils) => {
    wixUtils.addToCartWithCoupon({
      "productId": productId,
      "quantity": kwargs.quantity || 1,
      "couponCode": kwargs.couponCode || null,
      "successCallback": kwargs.successCallback || (() => {}),
      "errorCallback": kwargs.errorCallback || (() => {}),
    });
  });
}


